export const getCalendarCells = (year, month) => {
  const daysInCurrentMonth = new Date(year, month + 1, 0).getDate();
  const daysInPrevMonth = new Date(year, month, 0).getDate();
  const firstDayOfMonth = new Date(year, month, 1).getDay();
  const offset = (firstDayOfMonth + 6) % 7;
  const totalCells = 42;
  const cells = [];

  for (let i = offset - 1; i >= 0; i--) {
    cells.push({
      day: daysInPrevMonth - i,
      date: new Date(year, month - 1, daysInPrevMonth - i),
      currentMonth: false,
    });
  }

  for (let i = 1; i <= daysInCurrentMonth; i++) {
    cells.push({
      day: i,
      date: new Date(year, month, i),
      currentMonth: true,
    });
  }

  while (cells.length < totalCells) {
    const nextDay = cells.length - offset - daysInCurrentMonth + 1;
    cells.push({
      day: nextDay,
      date: new Date(year, month + 1, nextDay),
      currentMonth: false,
    });
  }

  return cells;
};
